import { TouchableOpacity, View } from 'react-native'
import Animated from 'react-native-reanimated'
import { convertHexToRGBA } from '../../utils'

export const TabBar = ({
  state,
  descriptors,
  navigation,
  theme,
}: {
  state: any
  descriptors: any
  navigation: any
  theme: any
}) => {
  return (
    <View style={{ flexDirection: 'row' }}>
      {state.routes.map((route: any, index: number) => {
        const { options } = descriptors[route.key]
        const label =
          options.tabBarLabel !== undefined
            ? options.tabBarLabel
            : options.title !== undefined
            ? options.title
            : route.name

        const isFocused = state.index === index

        const onPress = () => {
          const event = navigation.emit({
            type: 'tabPress',
            target: route.key,
            canPreventDefault: true,
          })

          if (!isFocused && !event.defaultPrevented) {
            navigation.navigate(route.name)
          }
        }

        const onLongPress = () => {
          navigation.emit({
            type: 'tabLongPress',
            target: route.key,
          })
        }
        return (
          <View style={{ flex: 1, height: 48 }}>
            <TouchableOpacity
              accessibilityRole="button"
              accessibilityState={isFocused ? { selected: true } : {}}
              accessibilityLabel={options.tabBarAccessibilityLabel}
              testID={options.tabBarTestID}
              onPress={onPress}
              onLongPress={onLongPress}
              style={{ flex: 1, height: 48, alignItems: 'center', justifyContent: 'center' }}>
              <Animated.Text
                style={
                  isFocused
                    ? { color: theme.brandColor, fontSize: 12, fontWeight: 'bold' }
                    : { color: convertHexToRGBA(theme.bodyTextColor, 50), fontSize: 12, fontWeight: '700' }
                }>
                {label}
              </Animated.Text>
            </TouchableOpacity>
            <View
              style={{
                borderBottomColor: isFocused ? theme.brandColor : convertHexToRGBA(theme.bodyTextColor, 10),
                borderBottomWidth: isFocused ? 3 : 1,
              }}
            />
          </View>
        )
      })}
    </View>
  )
}
